var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container category-container"},[_c('app-announcement',{staticClass:"mb-4",attrs:{"position":"top_product"}}),_vm._t("top"),_c('div',{staticClass:"card-columns"},[_vm._t("main")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }